import { Box, Grid, Typography, Link, Divider } from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { getFullImageUrl } from "../../../utils/getFullImageUrl"

export default function VenueFoodPackages({ detailsSx, tenant }) {
  const branch = tenant?.data?.branches?.[0]
  const foodPackagesImages = tenant?.data?.food_packages || []
  const socialMediaLinks = branch?.social_media_links || {}

  const socialPlatforms = [
    { keys: ["facebook"], label: "Facebook", id: "facebook" },
    { keys: ["instagram"], label: "Instagram", id: "instagram" },
    { keys: ["twitter", "x"], label: "Twitter (X)", id: "twitter-x" },
    { keys: ["tiktok"], label: "TikTok", id: "tiktok" },
  ]

  const visibleSocialLinks = socialPlatforms
    .map((platform) => ({
      ...platform,
      url: platform.keys.find((key) => !!socialMediaLinks?.[key]),
    }))
    .filter((platform) => !!platform.url)

  const sampleFoodItems = foodPackagesImages.slice(0, 4).map((img) => ({
    label: img?.name,
    img: getFullImageUrl(img?.image_url),
  }))

  return (
    <>
      <Typography
        sx={{
          my: 3,
          fontWeight: 700,
          fontSize: "18px",
          color: "text.heading",
        }}
      >
        Food & Packages
      </Typography>

      <Typography sx={detailsSx}>
        {branch?.food_packages_description ||
          "This venue offers in-house dining for events. For food packages, please coordinate directly with the venue."}
      </Typography>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        {sampleFoodItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              sx={{
                position: "relative",
                height: 220,
                borderRadius: 2,
                overflow: "hidden",
                cursor: "pointer",
              }}
            >
              <Box
                component="img"
                src={item.img || "/placeholder.jpg"}
                alt={item.label || "Food item"}
                sx={{
                  width: 160,
                  height: 220,
                  objectFit: "cover",
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "scale(1.05)" },
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 60%)",
                }}
              />
              <Typography
                sx={{
                  position: "absolute",
                  bottom: 10,
                  left: 12,
                  color: "#fff",
                  fontWeight: 500,
                  fontSize: "13px",
                }}
              >
                {item.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {visibleSocialLinks.map((platform) => (
        <Box
          key={platform.id}
          sx={{ display: "flex", alignItems: "center", mt: 2 }}
        >
          <Link
            href={socialMediaLinks[platform.url]}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
              fontWeight: 500,
              fontSize: "16px",
              color: "accent.main",
              textDecoration: "underline",
            }}
          >
            See more on {(branch?.branch_name || tenant?.data?.name) + "'s"}{" "}
            {platform.label}
          </Link>
          <ArrowForwardIcon
            sx={{ fontSize: 20, color: "accent.main", ml: 1 }}
          />
        </Box>
      ))}

      <Divider sx={{ my: 5 }} />
    </>
  )
}
